import { AspectRatio, ContainerVm } from 'qp-ui-interface';
import { CarouselSize, CarouselStyle, CarouselType } from '../shared-components/cards-carousel/model/cards-carousel-models';

export const getCarouselType = (container: ContainerVm): CarouselType => {
  const { style, size, resources, sourceType } = container;
  if (sourceType === CarouselStyle.ON_GOING) {
    return CarouselType.ON_GOING;
  } else if (style === CarouselStyle.ROUNDED) {
    return CarouselType.SMALL_CIRCLE;
  } else if (resources && resources[0]?.type === 'collection' && container?.aspectRatio?.includes('1x1')) {
    return CarouselType.SQUARE_SMALL;
  } else if (
    // if container is a continue watching container it will be regular and regular
    (style === CarouselStyle.REGULAR && size === CarouselSize.REGULAR) ||
    container.id.toLocaleLowerCase() === 'cvm-ContinueWatching' ||
    container?.sourceType?.includes('continue_watching')
  ) {
    return CarouselType.SQUARE_REGULAR;
  } else if (style === CarouselStyle.REGULAR && size === CarouselSize.LARGE) {
    return CarouselType.SQUARE_LARGE;
  } else {
    return CarouselType.SQUARE_REGULAR;
  }
};

export const getShowPlayIcon = (container: ContainerVm): boolean => {
  // Play icon should be shown only for continue watching container
  return getShowProgress(container);
};

export const getShowProgress = (container: ContainerVm): boolean => {
  if (container) {
    const { id, sourceType } = container;
    if (
      id.toLocaleLowerCase() === 'cvm-continuewatching' ||
      sourceType?.includes('continue_watching') ||
      id === 'cvm-player-morelikethis'
    ) {
      return true;
    }
  }
  return false;
};

export const showHeroByUrl = (url: string) => {
  return (
    !url.includes('/myhub') &&
    !url.includes('/search') &&
    !url.includes('/genres') &&
    !url.includes('/artist') &&
    !url.includes('/view-all')
  );
};

export const getCollectionPages = (aspectRatio: AspectRatio) => {
  switch (aspectRatio) {
    case '16x9':
    case '1x1':
    case '4x3':
    case '5x1':
      return 2;
    case '2x3':
      return 1;
    default:
      return 1;
  }
};
